import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { AlertProvider } from './contexts/AlertContext'; // Import AlertProvider
import Login from './pages/Login'; // Import updated Login component
import { publicRoutes, protectedRoutes, permissionRoutes } from './routes'; // Import routes
import MainLayout from './components/MainLayout'; // Assuming you have a layout for protected routes
import { AuthProvider } from './contexts/AuthContext'; // Assuming you have AuthProvider for authentication
import { LoadingProvider } from './contexts/LoadingContext'; // Assuming you have LoadingProvider
import AlertMessage from './components/AlertMessage'; // Assuming you have an AlertMessage component for displaying alerts

// Contexts and Providers
// import { AuthProvider } from "./contexts/AuthContext";
// import { AlertProvider } from "./contexts/AlertContext";
// import { LoadingProvider } from "./contexts/LoadingContext";
// import { WebSocketProvider } from "./contexts/WebSocketContext";
// import { MemberWebSocketProvider } from "./contexts/MemberWebSocketContext";
import { AdminAccessAlertProvider } from "./contexts/AdminAccessAlertContext";
import { RateLimitAlertProvider } from "./contexts/RateLimitAlertContext";
// import Chatbox from './pages/Chatbox';

import SearchModal from './components/SearchModal'; // Import the SearchModal component (adjust path if needed)
import { SearchProvider } from './contexts/SearchContext'; // Import SearchProvider
import { TrackerProvider } from "./contexts/TrackerContext";
import { Toaster } from 'react-hot-toast';

// Import the new Internet Status Context
import { InternetStatusProvider } from './contexts/InternetStatusContext';
import InternetStatusIndicator from './components/InternetStatusIndicator';


const App = () => {
  return (
    <Router>
      {/* <GoogleOAuthProvider clientId="250558744471-r449ll7v9fhqumea0utvtj0jae3n6odm.apps.googleusercontent.com"> */}
        <AlertProvider>
          <AuthProvider>
            <LoadingProvider>
            <RateLimitAlertProvider>
            <AdminAccessAlertProvider>
               {/* Add InternetStatusProvider here */}
              <InternetStatusProvider>

{/* Wrap with SearchProvider */}
              <SearchProvider> 
              <TrackerProvider>
                
              <AlertMessage />
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 3500,
                }}
              />

              {/* Add InternetStatusIndicator here */}
                <InternetStatusIndicator />

              <Routes>
                {/* Public Route with reCAPTCHA */}
                {publicRoutes}

                {/* Protected and Permission Routes */}
                <Route path="/" element={<MainLayout />}>
                  {protectedRoutes.map((route) => (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                  {permissionRoutes.map((route) => (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                </Route>
              </Routes>
              {/* <Chatbox></Chatbox> */}
              {/* SearchModal uses the context */}
              <SearchModal /> 
              </TrackerProvider>
              </SearchProvider>
              </InternetStatusProvider>
              </AdminAccessAlertProvider>
              </RateLimitAlertProvider>
            </LoadingProvider>
          </AuthProvider>
        </AlertProvider>
      {/* </GoogleOAuthProvider> */}
    </Router>
  );
};

export default App;
